import './Full.sass';

import * as Sentry from '@sentry/browser';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import _ from 'underscore';

import {
  resetPasswordUserActionSagas,
  updateAdminSaga,
} from '../../components/Admins/actionsSagas';
import Aside from '../../components/Aside';
import { loadAllWriters } from '../../components/Assignments/actionsSagas';
import {
  getIsQuestionOverview,
  getWriters as getAssignmentWriters,
} from '../../components/Assignments/selectors';
import Header from '../../components/Header';
import PasswordAlertModal from '../../components/Login/components/PasswordAlertModal';
import { getPermissions, getUser } from '../../components/Login/selectors';
import ModalWindow from '../../components/ModalWindow/ModalWindow';
// import EventListener from 'react-event-listener';
import { setQuery, setSearchFromHeader } from '../../components/Search/actions';
import { environmentName } from '../../constants/endpoints';
import * as HeaderOptions from '../../HeaderOptions';
import addAbilityToOpenModal from '../../utilities/modalHOC';
import { canPerformAction } from '../../utilities/permissionUtils';
import { connectSocket } from '../../utilities/socketService';

class Full extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sendActivity: true,
      showAlertPassword: false,
      isPasswordExpired: false,
    };
    this.hasLoadedWritersForMissionControlHeader = false;
  }

  componentDidMount() {
    // Connect socket for background requests
    connectSocket();
    this.loadWritersForMissionControlHeader();

    if (this.props.loggedUser?.isLoginAsAdmin === true) {
      this.setState({
        showAlertPassword: false,
      });
    } else if (this.props.loggedUser?.validPasswordCriteria === false) {
      this.setState({
        showAlertPassword: true,
        isPasswordExpired: false,
      });
    } else if (this.props.loggedUser?.isPasswordExpired === true) {
      this.setState({
        showAlertPassword: true,
        isPasswordExpired: true,
      });
    } else {
      // if it's undefined, NOT showing.
      this.setState({
        showAlertPassword: false,
      });
    }
  }

  componentDidUpdate(prevProps) {
    this.loadWritersForMissionControlHeader();

    if (this.props.loggedUser?.id) {
      Sentry.setUser({
        email: this.props.loggedUser.email,
        id: this.props.loggedUser.id,
      });
    }

    if (
      this.props.loggedUser?.validPasswordCriteria !==
        prevProps.loggedUser?.validPasswordCriteria ||
      this.props.loggedUser?.isPasswordExpired !==
        prevProps.loggedUser?.isPasswordExpired
    ) {
      if (this.props.loggedUser?.isLoginAsAdmin === true) {
        this.setState({
          showAlertPassword: false,
        });
      } else if (this.props.loggedUser?.validPasswordCriteria === false) {
        this.setState({
          showAlertPassword: true,
          isPasswordExpired: false,
        });
      } else if (this.props.loggedUser?.isPasswordExpired === true) {
        this.setState({
          showAlertPassword: true,
          isPasswordExpired: true,
        });
      } else {
        // if it's undefined, NOT showing.
        this.setState({
          showAlertPassword: false,
        });
      }
    }
  }

  getWritersList() {
    return _.values(this.props.writers || []);
  }

  loadWritersForMissionControlHeader() {
    const writers = this.getWritersList();

    if (
      window.location.pathname.startsWith('/home/mission-control') &&
      !this.hasLoadedWritersForMissionControlHeader &&
      writers.length === 0
    ) {
      this.hasLoadedWritersForMissionControlHeader = true;
      this.props.loadAllWriters();
    }
  }

  static getFirstAvailableAccount(permissions) {
    const availableAccount = HeaderOptions.accounts.find((account) => {
      if (account.permission) {
        return canPerformAction(account.permission, permissions);
      }
      return false;
    });

    return availableAccount ? availableAccount.route : '/home/accounts';
  }

  static getFirstAvailableSetting(permissions) {
    // Find the first setting page the user has permission to view
    const availableSetting = HeaderOptions.settings.find((setting) => {
      if (setting.permission) {
        return canPerformAction(setting.permission, permissions);
      }
      return false;
    });

    return availableSetting ? availableSetting.route : '/home/settings';
  }

  static getFirstAvailableMissionControl(permissions) {
    // Find the first mission control page the user has permission to view
    const availableMissionControl =
      HeaderOptions.missionControlSubHeaderOptions.find((missionControl) => {
        if (missionControl.permission) {
          return canPerformAction(missionControl.permission, permissions);
        }
        return false;
      });

    return availableMissionControl
      ? availableMissionControl.route
      : '/home/mission-control';
  }

  static getHeaderConfigFromRoutes(routes, permissions, user) {
    const routeWithHeader = routes.reverse().find((route) => route.header);
    const headerOptions = routeWithHeader.header;

    const filteredHeaderOptions = headerOptions
      .filter((option) => {
        if (option.permission) {
          return canPerformAction(option.permission, permissions);
        }
        return false;
      })
      .map((option) => {
        // Update dynamic routes for sections with sub-navigation
        if (option.name === 'Settings') {
          return {
            ...option,
            route: Full.getFirstAvailableSetting(permissions),
          };
        }
        if (option.name === 'Accounts') {
          return {
            ...option,
            route: Full.getFirstAvailableAccount(permissions),
          };
        }
        if (option.name === 'Mission Control') {
          return {
            ...option,
            route: Full.getFirstAvailableMissionControl(permissions),
          };
        }
        return option;
      });

    return filteredHeaderOptions;
  }

  getWritersAwaitingApprovalCount() {
    const writers = this.getWritersList();

    return writers.reduce((total, writerItem) => {
      const writer = Array.isArray(writerItem) ? writerItem[0] : writerItem;
      const assignments = writer?.assignments || [];

      return (
        total +
        assignments.filter((assignment) => assignment.status === 'Submitted')
          .length
      );
    }, 0);
  }

  addWritersAwaitingApprovalCount(tabs) {
    const writersAwaitingApprovalCount = this.getWritersAwaitingApprovalCount();

    return tabs.map((tab) =>
      tab.name === 'Writers'
        ? { ...tab, badgeCount: writersAwaitingApprovalCount }
        : tab,
    );
  }

  getSecondHeaderOptions(permissions) {
    const filterTabsByPermission = (tabs) =>
      tabs.filter((tab) => {
        if (tab.permission) {
          return canPerformAction(tab.permission, permissions);
        }
        return false;
      });

    if (window.location.pathname.startsWith('/home/accounts')) {
      return filterTabsByPermission(HeaderOptions.accounts);
    }
    if (window.location.pathname.startsWith('/home/settings')) {
      return filterTabsByPermission(HeaderOptions.settings);
    }
    if (window.location.pathname.startsWith('/home/mission-control')) {
      const missionControlSubHeaderOptions =
        this.addWritersAwaitingApprovalCount(
          HeaderOptions.missionControlSubHeaderOptions,
        );

      return filterTabsByPermission(missionControlSubHeaderOptions);
    }
    if (window.location.pathname.startsWith('/home/questions')) {
      return [];
    }
  }

  showHeader(questionOverview) {
    return (
      !window.location.pathname.startsWith('/home/questions/') &&
      !questionOverview
    );
  }

  render() {
    const { routes, permissions, questionOverview } = this.props;
    const headerOptions = Full.getHeaderConfigFromRoutes(routes, permissions);
    const secondHeaderOptions = this.getSecondHeaderOptions(permissions);
    return (
      <>
        {this.state.showAlertPassword ? (
          <PasswordAlertModal
            show={this.state.showAlertPassword}
            user={this.props.loggedUser}
            updateAdmin={this.props.updateAdmin}
            passwordExpired={this.state.isPasswordExpired}
          />
        ) : null}

        <div
          className={
            window.location.pathname.startsWith('/home/questions/') ||
            questionOverview
              ? 'app noMarginTopContent'
              : 'app'
          }
        >
          {/* this.state.sendActivity === true && (
          <EventListener
            target={document}
            onMouseMoveCapture={this.handleMouseMove}
          />
        ) */}
          {environmentName && environmentName != 'false' ? (
            <div
              className={
                environmentName === 'Development environment'
                  ? 'devBar'
                  : 'stagingBar'
              }
            >
              {environmentName}
            </div>
          ) : null}
          {this.showHeader(questionOverview) && (
            <Header {...this.props} headerOptions={headerOptions} />
          )}
          {this.showHeader(questionOverview) && secondHeaderOptions && (
            <Header
              {...this.props}
              headerOptions={secondHeaderOptions}
              secondHeader
            />
          )}
          <div className={secondHeaderOptions ? 'app-body' : 'noSecondHeader'}>
            <main
              className="main"
              style={secondHeaderOptions ? {} : { height: '100%' }}
            >
              <div className="container-fluid">{this.props.children}</div>
            </main>
            <Aside />
          </div>
          <ModalWindow
            showModal={this.props.modalVisibility}
            closeModalFunction={this.props.toggleModalVisibility}
            modalContent={this.props.modalContent}
            modalTitle={this.props.modalTitle}
            modalClassName={this.props.modalClassName}
            user={this.props.user}
            {...this.props}
          />
        </div>
      </>
    );
  }
}

Full.contextTypes = {
  router: PropTypes.object.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  setQuery: (query) => {
    dispatch(setQuery(query));
  },
  setSearchFromHeader: (value) => {
    dispatch(setSearchFromHeader(value));
  },
  resetPassword: (id, passwordFields) => {
    dispatch(resetPasswordUserActionSagas(id, passwordFields));
  },
  updateAdmin: (admin) => {
    dispatch(updateAdminSaga(admin));
  },
  loadAllWriters: () => {
    dispatch(loadAllWriters());
  },
});

const mapStateToProps = (state, ownProps) => ({
  permissions: getPermissions(state),
  loggedUser: getUser(state),
  questionOverview: getIsQuestionOverview(state),
  writers: getAssignmentWriters(state),
});

export default addAbilityToOpenModal(
  connect(mapStateToProps, mapDispatchToProps)(Full),
);
